import { cn } from '@lib/utils';
import { ChartBarIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';

export function Steps() {

  const steps = [
    {
      id: 'security',
      icon: <ShieldCheckIcon size={40} className="text-white" />,
      title: 'Segurança com autenticação facial dos alunos',
      description:
        'Nesta etapa você define os dados do superadmin. O superadmin terá acesso total ao painel CantinaPay. Cria usuários e tem acesso a todas as configurações.',
    },
    {
      id: 'speed',
      icon: <ZapIcon size={40} className="text-white" />,
      title: 'Atendimento 3x mais rápido com nossos totens',
      description:
        'Aqui você informa os dados comerciais do estabelecimento CNPJ e endereço precisam bater com registros oficiais para garantir conformidade (LGPD, regulamentação financeira, anti-fraude)',
    },
    {
      id: 'reports',
      icon: <ChartBarIcon size={40} className="text-white" />,
      title: 'Relatórios em tempo real para sua gestão',
      description: 'Revise atentamente todas as informações e confirme para concluir. Se necessário, atualize algum dado antes de prosseguir.',
    },
  ];

  
  return (
    <div className="flex max-w-[400px] flex-col space-y-4">
      {steps.map((step, index) => {
        return (
          <div key={step.id} className={cn('relative', index === 0 && 'z-[3]', index === 1 && 'z-[2]', index === 2 && 'z-[1]')}>
            <div className="flex items-start space-x-4">
              {/* Número do step */}
              <div className="relative flex-shrink-0">{step.icon}</div>

              {/* Conteúdo do step */}
              <div className="min-w-0 flex-1">
                <h3 className="font-noto text-xl font-extrabold text-white transition-colors">{step.title}</h3>
                {/* <p className="mt-1 text-base text-white">{step.description}</p> */}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}